define('views/files/Podio.Views.Files.CompactFile',['require','underscore','jquery','views/files/Podio.Views.Files.GenericFileItem','jst!files/_compactFile'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var viewGenericFileItem = require('views/files/Podio.Views.Files.GenericFileItem');

  var jstCompactFile = require('jst!files/_compactFile');

  return viewGenericFileItem.extend({
    className: 'uploaded-file-container',

    initialize: function() {
      _.bindAll(this, 'render');
    },

    render: function() {
      var fileView = $(this.getTemplate(jstCompactFile, {
        file: this.model,
        reference: this.options.reference,
        canDelete: this.options.canDelete
      }));
      fileView.appendTo(this.el);
    }
  });

});

